// Services
import { ApiServiceV2 } from "services";

const attempts = 3;
const sendCoords = async (coords, tried = 0) => {
  if (!coords.latitude || !coords.longitude || tried >= attempts) return;
  try {
    await ApiServiceV2.put({
      url: "/users_connected_records/update_my_coords",
      data: coords,
    });
  } catch (err) {
    await sendCoords(coords, tried + 1);
  }
};

export default sendCoords;
